import MenuButton from "app/ui/MenuButton";
import cn from "app/util/classnames";
import useTutorialState from "./useTutorialState";

interface TutorialMessagePanelProps {
  onContinue: () => void;
}

export default function TutorialMessagePanel({
  onContinue,
}: TutorialMessagePanelProps) {
  const { phaseData: tutorialPhase } = useTutorialState();

  return (
    <div className="w-full flex justify-center">
      <div
        className={cn(
          "relative",
          "flex flex-col",
          "m-1 mb-0 px-4 pt-1 pb-2 w-125 h-40",
          "bg-green-mid border border-black rounded-sm",
        )}
      >
        <div className="grow flex flex-col gap-1 items-start justify-center">
          {tutorialPhase?.message ?? <></>}
        </div>
        {tutorialPhase?.waitFor === "message" ? (
          <div className="mt-1 flex justify-center">
            <MenuButton className="text-sm w-auto px-4" onClick={onContinue}>
              OK
            </MenuButton>
          </div>
        ) : (
          <div
            className={cn(
              "absolute left-33 -bottom-3.5",
              "h-0 w-0",
              "border-x-50 border-x-transparent border-t-17 border-t-green-mid",
            )}
          />
        )}
      </div>
    </div>
  );
}
